module.exports = __webpack_public_path__ + "img/turkcell-t60.d56632d1.jpg";